import React from 'react'

const BalancedParenthesis = () => {
  return (
    <div>BalancedParenthesis</div>
  )
}

export default BalancedParenthesis